import React from 'react';
import { cn } from '@/context/global/utils/cn';

export type IconCallingMelodyProps = {
  className?: string;
  size?: number;
};

export default function IconCallingMelody({
  className = '',
  size = 24,
}: IconCallingMelodyProps) {
  return (
    <svg
      className={cn('text-white', className)}
      width={size}
      height={size}
      viewBox="0 0 34 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.82617 12.208V30.2014C8.80526 29.3932 7.31645 28.9678 5.65749 29.1379C2.55225 29.4357 0 31.7753 0 34.285C0 36.7947 2.55225 38.6663 5.65749 38.3686C8.76273 38.0708 11.315 35.7313 11.315 33.179V12.208H9.82617Z"
        fill="#EC2279"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9317 33.2218C10.9317 35.4762 8.63463 37.5606 5.82716 37.8158C3.01968 38.071 0.722656 36.4546 0.722656 34.2001C0.722656 31.9456 3.01968 29.8613 5.82716 29.6061C7.27343 29.4785 8.67717 29.7762 9.613 30.5844C10.166 31.0523 10.8891 31.7329 10.9742 33.2218H10.9317Z"
        fill="url(#paint0_linear_391_19534)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2512 32.4563C10.2512 34.1153 8.25197 35.6466 5.7848 35.9018C3.31762 36.1571 1.31836 35.0086 1.31836 33.3496C1.31836 31.6906 3.31762 30.1593 5.7848 29.9041C7.01839 29.7764 8.25197 29.9891 9.10272 30.5421C9.57064 30.8824 10.2087 31.3503 10.2938 32.4563H10.2512Z"
        fill="url(#paint1_linear_391_19534)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.5625 9.69824V27.6916C30.5416 26.8834 29.0528 26.458 27.3938 26.6282C24.2886 26.9259 21.7363 29.2655 21.7363 31.7752C21.7363 34.2849 24.2886 36.1566 27.3938 35.8588C30.4991 35.5611 33.0513 33.2215 33.0513 30.6692V9.69824H31.5625Z"
        fill="#EA2527"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.627 30.7545C32.627 33.009 30.3299 35.0933 27.5225 35.3485C24.715 35.6037 22.418 33.9873 22.418 31.7328C22.418 29.4783 24.715 27.394 27.5225 27.1388C28.9687 27.0112 30.3725 27.3089 31.3083 28.1171C31.8613 28.5851 32.5844 29.2657 32.6695 30.7545H32.627Z"
        fill="url(#paint2_linear_391_19534)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.9895 29.9456C31.9895 31.6045 29.9903 33.1359 27.5231 33.3486C25.0559 33.6038 23.0566 32.4553 23.0566 30.7963C23.0566 29.1374 25.0559 27.606 27.5231 27.3933C28.7567 27.2657 29.9903 27.4784 30.841 28.0314C31.3089 28.3717 31.947 28.8396 32.0321 29.9456H31.9895Z"
        fill="url(#paint3_linear_391_19534)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0391 12.3354V30.0736C10.7622 30.499 11.145 31.052 11.145 31.052V12.3354H10.0391Z"
        fill="url(#paint4_linear_391_19534)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.7754 9.91064V27.6488C32.4985 28.0742 32.8814 28.6272 32.8814 28.6272V9.91064H31.7754Z"
        fill="url(#paint5_linear_391_19534)"
      />
      <path d="M13.5693 6.55078H11.7402V20.4605H13.5693V6.55078Z" fill="#EC2279" />
      <path d="M15.7393 9.78369H13.9102V20.4606H15.7393V9.78369Z" fill="#922B8C" />
      <path d="M31.0947 5.01953H29.2656V20.4606H31.0947V5.01953Z" fill="#F15B27" />
      <path d="M17.9502 5.01953H16.1211V20.4606H17.9502V5.01953Z" fill="#0C73BA" />
      <path d="M20.1201 10.2944H18.291V20.4609H20.1201V10.2944Z" fill="#2BA8E0" />
      <path d="M22.333 3.31787H20.5039V20.4605H22.333V3.31787Z" fill="#3CB44A" />
      <path d="M24.501 5.61426H22.6719V20.4173H24.501V5.61426Z" fill="#8BC542" />
      <path d="M26.7139 7.82666H24.8848V20.4603H26.7139V7.82666Z" fill="#F8EC21" />
      <path d="M28.8838 0H27.0547V20.4605H28.8838V0Z" fill="#FBB03B" />
      <defs>
        <linearGradient
          id="paint0_linear_391_19534"
          x1="2.46669"
          y1="26.3732"
          x2="8.37941"
          y2="39.4322"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EF75AB" />
          <stop offset="0.5" stopColor="#EC2279" />
          <stop offset="1" stopColor="#EC2279" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_391_19534"
          x1="5.4496"
          y1="35.8597"
          x2="5.4496"
          y2="29.8109"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0326127" stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_391_19534"
          x1="24.162"
          y1="23.8634"
          x2="30.0747"
          y2="36.9649"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F37F5E" />
          <stop offset="0.5" stopColor="#EA2127" />
          <stop offset="1" stopColor="#D0222A" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_391_19534"
          x1="27.1998"
          y1="33.372"
          x2="27.1998"
          y2="27.3231"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.1" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_391_19534"
          x1="10.592"
          y1="13.5265"
          x2="10.592"
          y2="36.5393"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EF75AB" />
          <stop offset="0.5" stopColor="#EC2279" />
          <stop offset="1" stopColor="#EC2279" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_391_19534"
          x1="32.3284"
          y1="11.1017"
          x2="32.3284"
          y2="34.1145"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F37F5E" />
          <stop offset="0.5" stopColor="#EA2127" />
          <stop offset="1" stopColor="#D0222A" />
        </linearGradient>
      </defs>
    </svg>
  );
}
